/** Public contact endpoints — single source for announcement bar, mobile drawer, etc. */

export const WHATSAPP_GROUP_URL = 'https://chat.whatsapp.com/IT6ZCApuyJvHQIIFE26RfB';

export const PUBLIC_EMAIL = 'viagens@transserrano.com';

export const PUBLIC_PHONE_TEL = '+351966217787';

export const PUBLIC_PHONE_DISPLAY = '+351 966 217 787';

export const mailtoHref = `mailto:${PUBLIC_EMAIL}`;

export const telHref = `tel:${PUBLIC_PHONE_TEL}`;
